export default __webpack_public_path__ + "static/media/percentage.b64c90e0.svg";